import { render, staticRenderFns } from "./Mensajeria.vue?vue&type=template&id=2922cb36&scoped=true"
import script from "./Mensajeria.vue?vue&type=script&lang=js"
export * from "./Mensajeria.vue?vue&type=script&lang=js"
import style0 from "./Mensajeria.vue?vue&type=style&index=0&id=2922cb36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2922cb36",
  null
  
)

export default component.exports